const initialState = () => ({
  cards: [],
});

const isSameId = (first, second) => String(first) === String(second);

const getters = {
  getCards: (state, _getters, _rootState, rootGetters) => {
    const loggedUserId = rootGetters["app/getUserData"]?.id;

    if (loggedUserId == null) return [];

    return state.cards.filter((card) => isSameId(card.userId, loggedUserId));
  },

  getCount: (state, getters) => getters.getCards.length,
};

const mutations = {
  addCard(state, card) {
    const alreadyExists = state.cards.some((existingCard) => {
      const sameUser = isSameId(existingCard.userId, card.userId);
      const sameTask = isSameId(existingCard.taskId, card.taskId);
      const sameNotification =
        card.notificationId != null && isSameId(existingCard.notificationId, card.notificationId);

      return sameUser && (sameTask || sameNotification);
    });

    if (alreadyExists) return;

    state.cards.unshift(card);
  },

  removeCardByNotificationId(state, notificationId) {
    state.cards = state.cards.filter((card) => !isSameId(card.notificationId, notificationId));
  },

  removeCardByTaskId(state, taskId) {
    state.cards = state.cards.filter((card) => !isSameId(card.taskId, taskId));
  },

  clearCards(state) {
    state.cards = [];
  },
};

const actions = {
  pushCard({ commit, rootGetters }, card) {
    const loggedUserId = rootGetters["app/getUserData"]?.id;

    if (loggedUserId == null) return;

    commit("addCard", { ...card, userId: loggedUserId });
  },

  readAndRemove({ commit, dispatch }, card) {
    commit("removeCardByNotificationId", card.notificationId);

    if (!card.notificationId) return Promise.resolve();

    return dispatch("notifications/readNotifications", card.notificationId, { root: true });
  },
};

export default {
  namespaced: true,
  state: initialState(),
  getters,
  mutations,
  actions,
};
